import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const OrcamentoList = props => <DefaultDataTable data={props} />;
